// Google Sheets 接続パネル（Slice 5c）。
// 正式導線は Google OAuth + Picker。手動貼付は開発/障害時のフォールバック。
import { useState } from "preact/hooks";
import { config } from "../config";
import { connectGoogleSheet } from "./google-oauth";
import { setSheetsToken } from "./sheets-token";

export function SheetsTokenPanel({ error, onConnect }: { error?: string | null; onConnect: () => void }) {
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState(false);
  const [oauthError, setOauthError] = useState<string | null>(null);
  const oauthReady = !!config.googleOAuthClientId;

  async function onOAuthConnect() {
    setBusy(true);
    setOauthError(null);
    try {
      const result = await connectGoogleSheet({
        clientId: config.googleOAuthClientId ?? "",
        apiKey: config.googlePickerApiKey,
      });
      setSheetsToken(result.token);
      onConnect();
    } catch (e) {
      setOauthError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="ss-center">
      <div class="ss-login">
        <div class="ss-login-logo" />
        <h1 class="ss-login-title">スプレッドシートに接続</h1>
        <p class="ss-login-lead">
          このアプリは Google スプレッドシートをデータベースとして使います。
          Google アカウントで許可して接続してください（トークンは端末に保存されません）。
        </p>
        <button
          class="ss-login-btn"
          disabled={!oauthReady || busy}
          onClick={() => void onOAuthConnect()}
        >
          {busy ? "接続中…" : "Google で接続"}
        </button>
        {!oauthReady && (
          <div class="ss-login-err">Google OAuth Client ID が未設定です。管理者に設定を依頼してください。</div>
        )}
        {(oauthError || error) && <div class="ss-login-err">{oauthError ?? error}</div>}

        <details class="ss-token-help">
          <summary>手動トークンで接続する</summary>
          <ol>
            <li><a href="https://developers.google.com/oauthplayground" target="_blank" rel="noopener">OAuth 2.0 Playground</a> を開く</li>
            <li>Step 1 のリストから <strong>Google Sheets API v4</strong> → <code>https://www.googleapis.com/auth/spreadsheets</code> を選択</li>
            <li>[Authorize APIs] → 自分の Google アカウントで許可</li>
            <li>[Exchange authorization code for tokens] → 表示された <strong>Access token</strong> をコピー</li>
          </ol>
          <textarea
            class="rt-input"
            rows={3}
            placeholder="ya29. で始まるアクセストークンを貼り付け"
            value={token}
            onInput={(e) => setToken((e.target as HTMLTextAreaElement).value)}
          />
          <button
            class="ss-login-btn"
            disabled={token.trim().length < 20}
            onClick={() => {
              setSheetsToken(token.trim());
              onConnect();
            }}
          >
            手動トークンで接続
          </button>
        </details>
      </div>
    </div>
  );
}
